import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useState } from 'react';
import { FormTextField,TextField } from '../../ui/forms/input-field/text-field/text-field';
import { Button } from '../../ui/buttons/button';
import { Form } from '../../ui/forms/form';
import { LoginPayload, useLogin } from '../requests/use-login';
import { FormCheckbox } from '../../ui/forms/toggle/checkbox';
import { LinkStyle } from '../../ui/buttons/external-link';
import { SocialAuthSection } from './social-auth-section';
import { AuthLayout } from './auth-layout/auth-layout';
import { Trans } from '../../i18n/trans';
import { StaticPageTitle } from '../../seo/static-page-title';
import { useContext } from 'react';
import {
  SiteConfigContext,
  SiteConfigContextValue,
} from '../../core/settings/site-config-context';
import { useSettings } from '../../core/settings/use-settings';

export function LoginPage() {
  const [searchParams] = useSearchParams();
  const { pathname } = useLocation();

  const isWorkspaceLogin = pathname.includes('workspace');
  const searchParamsEmail = searchParams.get('email') || undefined;

  const { branding, registration, site } = useSettings();
  const siteConfig = useContext(SiteConfigContext);

  const demoDefaults =
    site.demo && !searchParamsEmail ? getDemoFormDefaults(siteConfig) : {};
  const form = useForm<LoginPayload>({
    defaultValues: { remember: true, email: searchParamsEmail, ...demoDefaults },
  });
  const login = useLogin(form);

  const heading = isWorkspaceLogin ? (
    <Trans
      values={{ siteName: branding?.site_name }}
      message="To join your team on :siteName, login to your account"
    />
  ) : (
    <Trans message="Sign in to your account" />
  );

  const message = !registration.disable && (
    <Trans
      values={{
        a: parts => (
          <Link className={LinkStyle} to="/register">
            {parts}
          </Link>
        ),
      }}
      message="Don't have an account? <a>&nbsp;Sign up.</a>"
    />
  );

  const isInvalid = !form.formState.isValid;
  const [emailText,setEmailText] = useState('Email');
  const [passwordText,setPasswordText] = useState('Password');
  let email = <Trans message="Email" />
  let password = <Trans message="Password" />
  const lng = (e: 'en' | 'tr') => {
   console.log('e',e);
    if (e === 'tr') {
      setEmailText('E-posta');
      setPasswordText('Şifre');
    } else {
      setEmailText('Email');
      setPasswordText('Password');
    }
  };
  return (
    <AuthLayout heading={heading} message={message} updateLang={lng} >
      <div className="my-auto flex flex-col justify-center px-4 pt-8  md:justify-start lg:w-[28rem]">
        <p className="text-center text-[22px] text-primary font-bold md:text-left md:leading-tight"><Trans message="Sign in to your account" /></p>
        <p className="mt-2 text-center text-[16px] md:text-left">
        {/* <Trans message="Don't have an account?"/>&nbsp;
          <Link to="/register" className="whitespace-nowrap font-semibold text-orange-500"><Trans message="Signup" /> </Link> */}
        </p>
        <SocialAuthSection dividerMessage={<Trans message="Or signup with" />} />
        
        <Form
          form={form}
          className="flex flex-col pt-3 md:pt-8"
          onSubmit={payload => {
            login.mutate(payload);
          }}
        >
          <div className="flex flex-col pt-4">
            <div className="relative flex transition focus-within:border-blue-600">
            <FormTextField
          className="w-full rounded-md flex-shrink appearance-none border-gray-300  text-base text-gray-700 placeholder-gray-400 focus:outline-none"
          name="email"
          type="email"
          id='cus_mail1'
          placeholder={emailText}
          disabled={!!searchParamsEmail}
          invalid={isInvalid}
          required
        />
            </div>
            </div>
            <div className="mb-4 flex flex-col pt-4">
            <div className="relative flex transition focus-within:border-blue-600">
            <FormTextField
          className="w-full rounded-md  appearance-none border-gray-300  text-base text-gray-700 placeholder-gray-400 focus:outline-none"
          name="password"
          type="password"
         
          // password placeholder
          invalid={isInvalid}
            placeholder={passwordText}
          required
        />
            </div>
            </div>
            <div className="block">
              <p className="mt-2 text-center text-[16px] md:text-left">
              <Trans message="Forgot Password?" />&nbsp;
                <Link className="whitespace-nowrap font-semibold text-orange-500" to="/forgot-password" tabIndex={-1}>
                  <Trans message="Recover" />
                </Link>
              </p>
            
          </div>

          <Button
            className="mt-6 w-full rounded-lg bg-primary px-4 py-2 text-center text-base font-semibold text-white shadow-md outline-none ring-blue-500 ring-offset-2 transition hover:bg-blue-700 focus:ring-2 "
            type="submit"

            disabled={login.isLoading}
          >
            <Trans message="Continue" />
          </Button>
        </Form>
      </div>




    
    </AuthLayout>
  );
}

function getDemoFormDefaults(siteConfig: SiteConfigContextValue) {
  if (siteConfig.demo.loginPageDefaults === 'randomAccount') {
    // random number between 0 and 100, padded to 3 digits
    const number = Math.floor(Math.random() * 100) + 1;
    const paddedNumber = String(number).padStart(3, '0');
    return {
      email: `admin@demo${paddedNumber}.com`,
      password: 'admin',
    };
  } else {
    return {
      email: 'admin@admin.com',
      password: 'admin',
    };
  }
}
